import { HELP_CENTER_BASE_URL } from '../../const'

const helpCenterUrl = HELP_CENTER_BASE_URL[process.env.NODE_ENV]

export default {
    namespaced: true,
    state: () => ({
        pageTutorials: {
            Treatments: {
                well_cards: {
                    title: 'Treatment Page',
                    videoUrl: `${helpCenterUrl}/videos/Treatment-page.mp4`
                },
                compare_wells: {
                    title: 'Compare Embryos',
                    videoUrl: `${helpCenterUrl}/videos/Compare-embryo.mp4`
                },
                performance_table: {
                    title: 'List View',
                    videoUrl: `${helpCenterUrl}/videos/List-view.mp4`
                },
                istanbul_table: {
                    title: 'Istanbul View',
                    videoUrl: `${helpCenterUrl}/videos/Istanbul-view.mp4`
                },
                cycle_report: {
                    title: 'Cycle Report',
                    videoUrl: `${helpCenterUrl}/videos/Cycle-report.mp4`
                },
                share_with_patients: {
                    title: 'Share Embryo',
                    videoUrl: `${helpCenterUrl}/videos/Share-embryo.mp4`
                }
            },
            HomePage: {
                title: 'Home Page',
                videoUrl: `${helpCenterUrl}/videos/Home-page.mp4`
            },
            Wells: {
                title: 'Well View',
                videoUrl: `${helpCenterUrl}/videos/Well-view.mp4`
            }
        },
        helpCenterContent: {
            videos: [
                {
                    _id: 1,
                    title: 'Home Page',
                    previewImageUrl: `${helpCenterUrl}/videos/Home-page-tutorial.jpg`,
                    videoUrl: `${helpCenterUrl}/videos/Home-page.mp4`
                },
                {
                    _id: 2,
                    title: 'Treatment Page',
                    previewImageUrl: `${helpCenterUrl}/videos/Treatment-page-tutorial.jpg`,
                    videoUrl: `${helpCenterUrl}/videos/Treatment-page.mp4`
                },
                {
                    _id: 3,
                    title: 'Compare Embryos',
                    previewImageUrl: `${helpCenterUrl}/videos/Compare-embryo-tutorial.jpg`,
                    videoUrl: `${helpCenterUrl}/videos/Compare-embryo.mp4`
                },
                {
                    _id: 4,
                    title: 'List View',
                    previewImageUrl: `${helpCenterUrl}/videos/List-view-tutorial.jpg`,
                    videoUrl: `${helpCenterUrl}/videos/List-view.mp4`
                },
                {
                    _id: 5,
                    title: 'Istanbul View',
                    previewImageUrl: `${helpCenterUrl}/videos/Istanbul-view-tutorial.jpg`,
                    videoUrl: `${helpCenterUrl}/videos/Istanbul-view.mp4`
                },
                {
                    _id: 6,
                    title: 'Well View',
                    previewImageUrl: `${helpCenterUrl}/videos/Well-view-tutorial.jpg`,
                    videoUrl: `${helpCenterUrl}/videos/Well-view.mp4`
                },
                {
                    _id: 7,
                    title: 'Cycle Report',
                    previewImageUrl: `${helpCenterUrl}/videos/Cycle-report-tutorial.jpg`,
                    videoUrl: `${helpCenterUrl}/videos/Cycle-report.mp4`
                },
                {
                    _id: 8,
                    title: 'Share Embryo',
                    previewImageUrl: `${helpCenterUrl}/videos/Share-embryo-tutorial.jpg`,
                    videoUrl: `${helpCenterUrl}/videos/Share-embryo.mp4`
                }
            ],
            manuals: [
                {
                    _id: 1,
                    title: 'Chloe EQ',
                    description: '',
                    fileUrl: `${helpCenterUrl}/manuals/CHLOE-EQ-User-Manual.pdf`
                }
            ],
            faqs: [
                {
                    _id: 1,
                    q: 'What is Fairtility?',
                    a: 'Fairtility™ is on a mission to transform IVF into a transparent process, delivering unparalleled visibility to both clinicians and patients with award winning, CHLOE™ (Cultivating Human Life through Optimal Embryos).<br/> Enabling standardized and objective embryo quality analysis, CHLOE is designed to reduce the number of IVF cycles to live birth, to minimize the emotional, physical and financial burden on prospective parents, and to enable more collaborative discussions between clinicians and patients.'
                },
                {
                    _id: 2,
                    q: 'What / who is CHLOE?',
                    a: 'CHLOE is the first and only transparent AI-based decision support tool that provides IVF professionals with access to increased data and insights about embryos. This means that embryologists and clinicians have more information available to them when they are evaluating embryos and making decisions during IVF treatments.'
                },
                {
                    _id: 3,
                    q: 'What is Transparent AI?',
                    a: 'Transparent AI is about understanding the WHY that makes up the WHAT.<br/> While the WHAT provides an AI score or outcome; whether it’s embryo quality or egg and sperm viability, the WHY will explain the biological events and how it arrived at this determination.<br/> Transparent AI ensures there is no existence of bias due to the transparency of the system.'
                },
                {
                    _id: 4,
                    q: 'How accurate is CHLOE?',
                    a: 'The data has shown that CHLOE has a blastocyst prediction accuracy rate of 96%, and implantation prediction accuracy of 73%. '
                },
                {
                    _id: 5,
                    q: 'Has CHLOE been proven to be safe and effective?',
                    a: "We strive to provide the highest level of care, and are committed to doing so in a safe and proven manner.<br/> CHLOE is registered  in Europe (CE marked)  and UK,.<br/> It has studied and researched  extensively to demonstrate its accuracy and effectiveness as a decision support tool for embryologists.<br/> Research about Chloe has been published in several peer reviewed journals, such as Human Reproduction, and Fertility & Sterility, and there are over 80 abstracts that have been presented at leading congresses including ESHRE, ASRM, etc. <br/><br/>In short, yes! We have a lot of data to show CHLOE’s effectiveness and benefit, and Fairtility was recently recognized with the 2023 MedTech Breakthrough Award for Women's Health Innovation."
                },
                {
                    _id: 6,
                    q: 'Does CHLOE compromise confidentiality in any way?',
                    a: 'No!  CHLOE is GDPR certified and HIPAA compliant.'
                },
                {
                    _id: 7,
                    q: 'Does CHLOE mean anything?',
                    a: 'Yes! The name Chloe comes from Greek origin, and means “green sprouts,” and represents blooming and fertility.  <br/>Fairtility also use it as an acronym: Cultivating Human Life through Optimal Embryos.'
                },
                {
                    _id: 8,
                    q: 'Where do the patient identifiers come from?',
                    a: 'We take the identifiers from the timelapse instrument, whether this be generated by the TLI or manually entered. For Vitrolife instruments, this is either the patient ID or treatment ID + slide ID. For Genea instruments, this is the ID1 and ID2. For Esco instruments, this is the patient ID + cycle code.'
                },
                {
                    _id: 9,
                    q: 'How do we use CHLOE?',
                    a: 'Please refer to our detailed manual in the Help Centre.'
                },
                {
                    _id: 10,
                    q: 'I need assistance, who do I contact?',
                    a: 'For technical support, please use the HELP icon on the bottom right of CHLOE.<br/>  For general queries, please contact your Fairtility Representative'
                },
                {
                    _id: 11,
                    q: 'What information form the embryo influences the EQ score?',
                    a: 'CHLOE analyses each image along with the image timestamp and compares this with its training dataset of know implantation embryos to give a score between 1-10 (10 being the highest chance of implantation)'
                },
                {
                    _id: 12,
                    q: 'What is the difference between the EQ and BLAST score?',
                    a: 'The EQ score is related to the chance of implantation.<br/> The BLAST score is related to the chance of the embryo reaching the blastocyst stage.'
                },
                {
                    _id: 13,
                    q: 'Why has the EQ score not changed from Day 5-Day 6',
                    a: 'The EQ score algorithm takes its final score at 120hr.<br/> Any embryo development after this timeframe will not change the EQ score'
                },
                {
                    _id: 14,
                    q: 'What does the EQ and BLAST score start to score embryos',
                    a: 'From 30hr post insemination.'
                },
                {
                    _id: 15,
                    q: 'How often do the EQ and BLAST scores update?',
                    a: 'Every 10 new images, CHLOE will re-run the data and update the scores.'
                },
                {
                    _id: 16,
                    q: 'Can I amend the incubator name?',
                    a: 'Yes! Simply click the pen icon next to the incubator name to add a different name or number.  '
                },
                {
                    _id: 17,
                    q: 'Why aren’t embryo images showing on the CHLOE Cycle Report?',
                    a: 'Please ensure that the embryos you wish to include on the cycle report have a fate.<br/> Any embryos without a fate will not appear on the report.'
                },
                {
                    _id: 18,
                    q: 'Can we do research on CHLOE data?',
                    a: 'You are able to download an individual slide’s CHLOE data by clicking the icon in the Table or Istanbul View. If you wish to do research on a larger dataset, please reach out to your Fairtility representative to discuss your ideas.'
                },
                {
                    _id: 19,
                    q: 'If we share the embryo videos with the patients, what do they see?',
                    a: 'Patients do not see any algorithm score or morphokinetic data.<br/> All they see is the video of their embryos, their respective fates and a generic simple summary of what to expect to see on each day.'
                },
                {
                    _id: 20,
                    q: 'Can I add my clinic logo to the Reports?',
                    a: 'Yes!  Simple go to the Settings and add in the Clinic Logo section'
                },
                {
                    _id: 21,
                    q: 'Can CHLOE integrate with our EMR system?',
                    a: 'Maybe!  It depends on the EMR.  Please reach out to your Fairtility representative to discuss further.'
                },
                {
                    _id: 22,
                    q: 'How does CHLOE increase lab efficiency?',
                    a: 'CHLOE does automatic fertilization checks, morphokinetic annotations and cell-counting, so you don’t have to.<br/> You can connect to CHLOE remotely via a computer, smart phone or tablet so there’s no need to use a dedicated computer or the TLI itself.<br/> For multi-centre networks, all TLIs can be accessed via one login, so no need to keep logging in to different systems.'
                }
            ],
            documents: []
        }
    }),
    getters: {
        tutorialForCurrentView: (state, getters, rootState) => currentRoute => {
            const componentTutorialForRoute = state.pageTutorials[currentRoute.name]
            if (componentTutorialForRoute) {
                let componentTutorial
                if (currentRoute.name === 'Treatments') {
                    componentTutorial = [
                        componentTutorialForRoute[rootState.navigation.currentView],
                        componentTutorialForRoute['cycle_report'],
                        componentTutorialForRoute['share_with_patients']
                    ]
                } else {
                    componentTutorial = componentTutorialForRoute[rootState.navigation.currentView]
                }
                return componentTutorial || [componentTutorialForRoute]
            } else {
                return null
            }
        }
    },
    mutations: {},
    actions: {}
}
